<template>
  <CatalogSelect
    :id="id"
    :is-disabled="isDisabled"
    :fetchData="fetchData"
    :searchData="searchData"
    v-on="$listeners"
  >
    <template v-slot:create-catalog="{ refresh }">
      <worker-status @refresh="refresh"/>
    </template>
  </CatalogSelect>
</template>

<script>
import catalogs from "../../../network/catalogs";
import CatalogSelect from "../CatalogSelect.vue";
import WorkerStatus from "./WorkerStatus";

export default {
  name: "WorkerStatusSelect",
  components: { CatalogSelect, WorkerStatus },
  mixins: [ catalogs ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
  },
  methods: {
    async fetchData(id) {
      return await this.getWorkerStatusById(id);
    },
    async searchData(query) {
      return await this.getWorkerStatusesSearch(query);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerStatuses/WorkerStatusSelect.vue